module.exports = __webpack_public_path__ + "img/BAU Seniors_8.30d34c04.jpg";